import React from 'react';
import { Link } from 'react-router-dom';

// OWA brand logo — 2026 metallic wordmark (FINAL LOGO), exported with a
// transparent background so it sits cleanly on both the white sticky header
// and the dark hero / footer.
//
//   variant 'header' → coin only on mobile/tablet, full logo on desktop (lg+)
//                      (keeps the compact header uncluttered on small screens)
//   variant 'footer' → full logo at every size
// Light mode gives the metallic logo a low-contrast white/near-white header
// behind it, so it needs its own dark navy backing chip to stay readable.
// Dark mode already has a dark header, so the chip is disabled there.
//
// The coin is a circular badge and the wordmark is a wide rectangle, so they
// each need their own chip shape — sharing one chip with asymmetric padding
// made the circular coin sit inside a stadium-shaped pill instead of a true
// circle, leaving it looking unevenly cropped at the top/bottom.
const COIN_CHIP = 'rounded-full bg-[#0b1c26] dark:bg-transparent p-1.5 dark:p-0';
const WORDMARK_CHIP = 'rounded-full bg-[#0b1c26] dark:bg-transparent px-4 py-2.5 dark:px-0 dark:py-0';

export default function BrandLogo({ variant = 'header', to = '/' }) {
  const inner =
    variant === 'footer' ? (
      <img
        src="/owa-logo-full.webp"
        alt="OWA — Origin Wild Adventure"
        className="h-14 md:h-16 w-auto"
      />
    ) : (
      <>
        <span className={`inline-flex flex-shrink-0 items-center justify-center lg:hidden ${COIN_CHIP}`}>
          <img src="/owa-coin.webp" alt="OWA" className="h-11 w-11 flex-shrink-0 object-contain" />
        </span>
        <span className={`hidden lg:inline-flex flex-shrink-0 items-center ${WORDMARK_CHIP}`}>
          <img
            src="/owa-logo-full.webp"
            alt="OWA — Origin Wild Adventure"
            className="h-12 w-auto flex-shrink-0"
          />
        </span>
      </>
    );

  if (!to) return inner;
  return (
    <Link to={to} aria-label="OWA — Origin Wild Adventure" className="inline-flex flex-shrink-0 items-center">
      {inner}
    </Link>
  );
}
